import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Card } from 'transfix-ui/components/Card'
import { ICarrier, ICarrierEquipmentState } from 'types/carrier'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { getEquipment } from 'apps/carrier/utils/actions/equipment'
import { IStore } from 'apps/carrier/utils/reducers'
import { CompanyInformation } from './CompanyInformation'
import { FleetInformation } from './FleetInformation'
import ExtendedCarrierScorecard from './components/ExtendedCarrierScorecard'
import { useCarrierExtendedInformation } from './components/ExtendedCarrierScorecard/hooks/useCarrierExtendedInformation'
import { useCarrierScoreData } from './hooks/useCarrierScoreData'

interface ISelector {
  equipment: ICarrierEquipmentState
  carrierData?: ICarrier
}

export const CarrierSummary = () => {
  const dispatch = useDispatch()
  const { getFlag } = useFeatureFlagContext()
  const { carrierData, equipment } = useSelector<IStore, ISelector>(store => ({
    carrierData: store.carrier.carrierDetails,
    equipment: store.carrierEquipment,
  }))
  const { loadCarrierScoreData } = useCarrierScoreData()

  const { enabled: isNewCarrierProfileSidebarEnabled } = getFlag('newCarrierProfileSidebar')
  const { data: extendedCarrierData } = useCarrierExtendedInformation(carrierData?.id || '')

  useEffect(() => {
    if (carrierData?.id) {
      dispatch(getEquipment(carrierData.id))
      loadCarrierScoreData(`${carrierData.id}`)
    }
  }, [carrierData?.id])

  const {
    bounceRate,
    carrierId,
    carrierName,
    carrierScore,
    dotNumber,
    hqValue,
    mcNumber,
    onTimeRate,
    rate,
    shipmentsCount,
    status,
    trackingRate,
  } = extendedCarrierData

  if (!carrierData) return <></>
  return (
    <Card>
      {isNewCarrierProfileSidebarEnabled ? (
        <CompanyInformation carrier={carrierData} />
      ) : (
        <div>
          <h3 className='mt2 mb4'>Carrier Summary</h3>
          <ExtendedCarrierScorecard
            carrierName={carrierName}
            mcNumber={mcNumber}
            dotNumber={dotNumber}
            hqValue={hqValue}
            status={status}
            rate={rate}
            bounceRate={bounceRate}
            onTimeRate={onTimeRate}
            trackingRate={trackingRate}
            carrierScore={carrierScore}
            carrierId={carrierId}
            shipmentsCount={shipmentsCount}
            reduced
          />
          <hr className='bg-disabled' />
          <CompanyInformation carrier={carrierData} />
          <hr className='bg-disabled' />
          <FleetInformation data={equipment} />
        </div>
      )}
    </Card>
  )
}
